var countdown = 60;
/**
 * 用户登录
 */
// export const username_and_password_login = () => {
//     console.log(window);
//     var username = $('#exampleInputUserName').val();
//     var password = $('#exampleInputPassword').val();
//     if (username == null || username.length <= 0) {
//         layer.alert('请输入用户名!', { icon: 6 });
//         return;
//     }
//     if (password == null || password.length <= 0) {
//         layer.alert('请输入密码!', { icon: 6 });
//         return;
//     }
//     $.ajax({
//         url: serverUrl+"/users/user_and_password_login",
//         type: "post",
//         data: {
//             username: username,
//             password: password
//         },
//         cache: false,
//         dataType: 'json',
//         success: function (data) {
//             if (data.code == 200) {
//                 layer.msg('登录成功!', { icon: 6 });
//                 location.href = "/notice";
//             }
//             else {
//                 layer.alert('登录失败!', { icon: 6 });
//             }
//         }

//     });
// }
export const username_and_password_login = () => {
    var username = $('#exampleInputUserName').val();
    var password = $('#exampleInputPassword').val();
    if (username == null || username.length <= 0) {
        layer.alert('请输入用户名!', {icon: 6});
        return;
    }
    if (password == null || password.length <= 0) {
        layer.alert('请输入密码!', {icon: 6});
        return;
    }
    $.ajax({
        url: serverUrl + "/login",
        type: "post",
        data: JSON.stringify({
            username: username,
            password: password,
            logintype: 1
        }),
        dataType: "json",
        contentType: "application/json",
        async: true,
        success: function (data) {
            if (data.code == 200) {
                layer.msg('登录成功，请稍等!', {
                    icon: 16,
                    zIndex: 2
                });
                $("#loginModal").modal('hide');
                localStorage.setItem("username", username)
                localStorage.setItem("token", data.token)
                localStorage.setItem("showLogin", 1)
                let header = {}
                $.ajax({
                    url: serverUrl + "/userinfo",
                    type: "get",
                    async: true,
                    headers: (header = {
                        username: username,
                        Authorization: "Api_Bearer " + data.token,
                        //'connection':'keep-alive',
                        "Content-Type": "application/json",
                    }),
                    success: function (authdata) {
                        if (authdata.code == 200) {
                            localStorage.setItem("authdata", JSON.stringify(authdata))
                            let href = decodeURIComponent(window.location.href);
                            let redirectUrl;
                            if (href.includes('redirect=')) {
                                redirectUrl = href.split('redirect=')[1] + (href.split('redirect=')[1].includes("?") ? "&" : "?") + 'tokenSignKey=' + data.token;
                                window.location.href = redirectUrl
                            } else {
                                var script = document.createElement("script");
                                script.setAttribute("type", "text/javascript");
                                script.setAttribute("reload", "1");
                                script.setAttribute("src", "https://dis.qidao123.com/plugin.php?id=qidaoData:synclogin&syncToken="+data.token);
                                document.getElementsByTagName('head')[0].appendChild(script);
                                setTimeout(() => {
                                    if (window.location.href.indexOf("LocateApply") > -1) {
                                        location.href = "/LocateApply";
                                        location.reload();
                                    } else {
                                        location.href = "/notice";
                                    }
                                }, 3000)
                            }
                        }
                    }
                })
                //location.reload();

            } else {
                localStorage.setItem("showLogin", 0);
                layer.alert(data.msg, {icon: 6});
            }
        }

    });
}

export default {
  username_and_password_login
}

/**
 * 用户验证码登录
 */
export const username_and_yzm_login = () => {
    var username = $('#exampleInputPhone').val();
    var yzmcode = $('#exampleInputyzm').val();
    if (username == null || username.length <= 0) {
        layer.alert('请输入手机号!', { icon: 6 });
        return;
    }
    if (yzmcode == null || yzmcode.length <= 0) {
        layer.alert('请输入验证码!', { icon: 6 });
        return;
    }
    $.ajax({
        url: "/users/username_and_yzm_login",
        type: "post",
        data: {
            username: username,
            yzmcode: yzmcode
        },
        cache: false,
        dataType: 'json',
        success: function (data) {
            if (data.code == 200) {
                layer.msg('登录成功!', { icon: 6 });
                localStorage.setItem("username", username)
                localStorage.setItem("token", data.token)
                localStorage.setItem("showLogin", 1)
                location.href = "/notice";
            }
            else {
                layer.alert('登录失败!', { icon: 6 });
            }
        }

    });
}
/**
 * 用户注销
 */
export const user_loginout = () => {

    $.ajax({
        url: "/users/loginout",
        type: "post",
        data: {

        },
        cache: false,
        dataType: 'json',
        success: function (data) {
            if (data.code == 200) {
                layer.msg('注销成功!', { icon: 6 });
                location.reload();
            }
            else {
                layer.alert('注销失败!', { icon: 6 });
            }
        }

    });
}
/**
 * 注册成功直接登录
 * @param username
 * @param password
 */
export const reg_success_login = (username, password) => {
    if (username == null || username.length <= 0) {
        layer.msg('用户名不能为空!', { icon: 6 });
        return;
    }
    if (password == null || password.length <= 0) {
        layer.alert('密码不能为空!', { icon: 6 });
        return;
    }
    $.ajax({
        url: "/users/user_and_password_login",
        type: "post",
        data: {
            username: username,
            password: password
        },
        cache: false,
        dataType: 'json',
        success: function (data) {
            if (data.code == 200) {
                layer.msg('登录成功!', { icon: 6 });
                location.reload();
            }
            else {
                layer.msg('登录失败!', { icon: 6 });
            }
        }

    });
}
/**
 * 发送验证码
 * @param btnSendSms
 */
export const sendUpdateSms = (btnSendSms) => {
    $('#' + btnSendSms).addClass("layui-btn-disabled").attr("disabled", true);
    $.ajax({
        url: "/users/get_update_sms_code",
        type: "post",
        data: {
        },
        cache: false,
        dataType: 'json',
        success: function (data) {
            if (data.code == 200) {
                settime(btnSendSms);
                layer.alert('发送验证码成功!', { icon: 6 });
                let css = document.getElementsByClassName('layui-layer-dialog');
                for (let i = 0; i < css.length; i++) {
                    if(css[i].className.indexOf('layer-anim') == -1){
                        css[i].style.display = 'none'
                    }
                }
            }
            else {
                layer.alert('发送验证码失败!', { icon: 6 });
                $('#' + btnSendSms).removeClass("layui-btn-disabled").attr("disabled", false);
                let css = document.getElementsByClassName('layui-layer-dialog');
                for (let i = 0; i < css.length; i++) {
                    if(css[i].className.indexOf('layer-anim') == -1){
                        css[i].style.display = 'none'
                    }
                }
            }
        }

    });
}
/**
 * 发送验证码
 * @param exampleInputPhone
 * @param btnSendSms
 */
export const sendSms = (exampleInputPhone, btnSendSms,area) => {
    console.log(area,111)
    return
    $('#' + btnSendSms).addClass("layui-btn-disabled").attr("disabled", true);
    var phone = $('#' + exampleInputPhone).val();
    if(area){
        phone = area + $('#' + exampleInputPhone).val();
    }
    if (phone == null || phone.length <= 0) {
        $('#' + btnSendSms).removeClass("layui-btn-disabled").attr("disabled", false);
        return;
    }
    $.ajax({
        url: "/users/get_sms_code",
        type: "post",
        data: {
            phone: phone
        },
        cache: false,
        dataType: 'json',
        success: function (data) {
            if (data.code == 200) {
                settime(btnSendSms);
                layer.alert('发送验证码成功!', { icon: 6 });
                let css = document.getElementsByClassName('layui-layer-dialog');
                for (let i = 0; i < css.length; i++) {
                    if(css[i].className.indexOf('layer-anim') == -1){
                        css[i].style.display = 'none'
                    }
                }
            }
            else {
                layer.alert('发送验证码失败!', { icon: 6 });
                $('#' + btnSendSms).removeClass("layui-btn-disabled").attr("disabled", false);
                let css = document.getElementsByClassName('layui-layer-dialog');
                for (let i = 0; i < css.length; i++) {
                    if(css[i].className.indexOf('layer-anim') == -1){
                        css[i].style.display = 'none'
                    }
                }
            }
        }

    });
}

/**
 * 验证码定时器
 * @param btnSendSms
 */
function settime(btnSendSms) {
    if (countdown == 0) {
        $('#' + btnSendSms).text("重新发送");
        $('#' + btnSendSms).removeClass("layui-btn-disabled").attr("disabled", false);
        countdown = 60;
        return;
    } else {
        $('#' + btnSendSms).text("重新发送(" + countdown + ")");
        countdown--;
    }
    setTimeout(function () {
        settime(btnSendSms)
    }
        , 1000)
}
//替换指定传入参数的值,paramName为参数,replaceWith为新值
function replaceParamVal(oUrl, paramName, replaceWith) {
    var re = eval('/(' + paramName + '=)([^&]*)/gi');
    var nUrl = oUrl.replace(re, paramName + '=' + replaceWith);
    return nUrl;
}
/*
*获取URL参数
*/
export const GetQueryString = (name) => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return unescape(r[2]);
    }
    return null;
}

function getDateTimeStamp(dateStr) {

    if (dateStr != null || dateStr != '') {
        return Date.parse(dateStr.replace(/-/gi, "/"));
    }
    return null;
}
function getDateDiff(dateTimeStamp) {
    var minute = 1000 * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var halfamonth = day * 15;
    var month = day * 30;
    var year = day * 365;
    var now = new Date().getTime();
    var diffValue = now - dateTimeStamp;
    if (dateTimeStamp == null) {
        return "未知";
    }
    if (diffValue < 0) { return; }
    var yearC = diffValue / year;
    var monthC = diffValue / month;
    var weekC = diffValue / (7 * day);
    var dayC = diffValue / day;
    var hourC = diffValue / hour;
    var minC = diffValue / minute;
    if (yearC >= 1) {
        result = "" + parseInt(yearC) + "年前";
    }
    if (monthC >= 1) {
        result = "" + parseInt(monthC) + "月前";
    }
    else if (weekC >= 1) {
        result = "" + parseInt(weekC) + "周前";
    }
    else if (dayC >= 1) {
        result = "" + parseInt(dayC) + "天前";
    }
    else if (hourC >= 1) {
        result = "" + parseInt(hourC) + "小时前";
    }
    else if (minC >= 1) {
        result = "" + parseInt(minC) + "分钟前";
    } else {
        result = "刚刚";
    }

    return result;
}

/**
 * 文章内容点赞
 * @param operationId
 * @param operationType
 * @param control_obj
 * @param LikeNum_obj
 */
export const setarticlelike = (operationId, operationType, control_obj, LikeNum_obj) => {
    control_obj.css("pointer-events", "none");
    let authdata = localStorage.getItem("authdata")
    if (authdata == null) {
        layer.alert('用户未登陆!', { icon: 6 });
        return;
    }
    authdata = JSON.parse(authdata)
    let userId = authdata.data.userId
    let realName = authdata.data.realName
    let username = localStorage.getItem("username")
    let token = localStorage.getItem("token")

    let data = {
        "operationId": operationId,
        "operationType": operationType,
        "createById": userId,
        "createbyName": realName
    }
    $.ajax({
        url: serverUrl + "/userdata/setarticlelike",
        type: "post",
        async: true,
        data: JSON.stringify(data),
        dataType: "json",
        contentType: "application/json",
        headers: {
            "username": username,
            "Authorization": "Api_Bearer " + token,
            'Content-Type': 'application/json'
        },
        success: function (data) {
            if (data.code == 200) {
                control_obj.css("pointer-events", "none");
                LikeNum_obj.html(parseInt(LikeNum_obj.html()) + 1);
                layer.alert('点赞成功!', { icon: 6 });
            }
            else {
                control_obj.css("pointer-events", "");
                layer.alert(data.msg, { icon: 6 });
            }
        }

    });
}
/**
 * 获取文章顶赞状态
 * @param operationId
 * @param operationType
 * @param control_obj
 */
export const getarticlelikestatus = (operationId, operationType, control_obj) => {
    control_obj.css("pointer-events", "");
    let authdata = localStorage.getItem("authdata")
    if (authdata == null) {
        layer.alert('用户未登陆!', { icon: 6 });
        return;
    }
    authdata = JSON.parse(authdata)
    let userId = authdata.data.userId
    updatevisitdetaildata('post.vue', 'getarticlelikestatus');
    let data = {
        "operationId": operationId,
        "operationType": operationType,
        "createById": userId
    }
    let username = localStorage.getItem("username")
    let token = localStorage.getItem("token")
    $.ajax({
        url: serverUrl + "/userdata/getarticlelikestatus",
        type: "post",
        async: true,
        data: JSON.stringify(data),
        headers: {
            "username": username,
            "Authorization": "Api_Bearer " + token,
            'Content-Type': 'application/json'
        },
        dataType: "json",
        contentType: "application/json",
        success: function (data) {
            if (data.code == 200) {
                control_obj.css("pointer-events", "none");
            }
        }

    });
}
function decodeUnicode(str) {
    str = str.replace(/\\/g, "%");
    return unescape(str);
}
function encodeUnicode(str) {
    var res = [];
    for (var i = 0; i < str.length; i++) {
        res[i] = ("00" + str.charCodeAt(i).toString(16)).slice(-4);
    }
    return "\\u" + res.join("\\u");
}

/**
 * 设置评论点赞
 * @param operationId
 * @param operationType
 * @param control_obj
 * @param LikeNum_obj
 */
function setarticlecommentlike(operationId, operationType, control_obj, LikeNum_obj) {
    //$('#'+btnSendSms).addClass("layui-btn-disabled").attr("disabled",true);
    control_obj.css("pointer-events", "none");
    $.ajax({
        url: "/users/setarticlecommentlike",
        type: "post",
        data: {
            operationId: operationId,
            operationType: operationType
        },
        cache: false,
        dataType: 'json',
        success: function (data) {
            if (data.code == 200) {
                control_obj.css("pointer-events", "none");
                LikeNum_obj.html(parseInt(LikeNum_obj.html()) + 1);
                layer.alert('点赞成功!', { icon: 6 });
            }
            else {
                control_obj.css("pointer-events", "");
                layer.alert(data.msg, { icon: 6 });

                //$('#'+btnSendSms).removeClass("layui-btn-disabled").attr("disabled",false);
            }
        }

    });
}
/**
 * 获取评论点赞状态
 * @param operationId
 * @param operationType
 * @param control_obj
 */
function getarticlecommentlikestatus(operationId, operationType, control_obj) {
    control_obj.css("pointer-events", "");
    $.ajax({
        url: "/users/getarticlecommentlikestatus",
        type: "post",
        data: {
            operationId: operationId,
            operationType: operationType
        },
        cache: false,
        dataType: 'json',
        success: function (data) {
            if (data.code == 200) {
                control_obj.css("pointer-events", "none");
            }
        }

    });
}

/**
 * 获取评论朋友状态
 * @param commentId
 * @param createById
 */
function fillfriend(commentId, createById, createBy, createUserAvatar) {
    $.ajax({
        url: "/message/firendstatus",
        type: "post",
        data: {
            friendsUserid: createById
        },
        cache: false,
        dataType: 'json',
        success: function (data) {
            if (data.code == 200) {
                let auth = data.data.auth;
                let status = data.data.status;
                if(status == 0) {
                    $('#friend' + commentId).show();
                    $('#friend' + commentId).html("加好友");
                    $('#friend' + commentId).bind("click", function () {
                        addfriendsTips(commentId, createById);
                    });
                }else if(status == 11){
                    $('#friend'+commentId).show();
                    $('#friend'+commentId).html("已申请好友");
                }
                    
                $('#messages'+commentId).show();
                if (auth == 2 || (auth == 1 && status == 1)) {
                   $('#messages'+commentId).html("<span class='docs-btns2'data-status=0 data-uid=1 >发消息</span>");
                } else {
                   $('#messages'+commentId).html("<span class='docs-btns2'data-status=0 data-uid=1 title='用户设置，只有好友才能发送消息，请先申请好友' style='background-color:rgba(35, 47, 62, 0.6)'>发消息</span>");
                }
                $('#messages'+commentId).bind("click",function(){
                    if (auth == 2 || (auth == 1 && status == 1)) {
                        messagefriends(commentId,createById,createBy,createUserAvatar);
                    } else {
                        //示范一个公告层
                        layer.open({
                            type: 1,
                            title: '提示', 
                            closeBtn: false,
                            area: "410px;",
                            shade: 0.8,
                            id: "LAY_layuipro", //设定一个id，防止重复弹出
                            btn: ["确定"],
                            //,skin:'layer-ext-myskin'
                            btnAlign: "c",
                            moveType: 1, //拖拽模式，0或者1
                            content:'<div style="text-align: center;">用户设置，只有好友才能发送消息，请先申请好友。</div>'
                        });
                    }
                });
            }

        }
    });
}

function addfriendsTips(commentId,createById) {
    // lw 2024-1-9
    layer.prompt({
        formType: 2,
        title: '请先完成“职业认证”证明自己的身份并输入验证请求信息(通过率更高)',
        maxlength: 100,
        area: ['400px', '60px'],
        placeholder: "最大100文字"
    }, function(value, index, elem){
        if (value == null || value == '') {
            layer.alert('请先完成“职业认证”证明自己的身份并输入验证请求信息(通过率更高)', {icon: 6});
            return;
        }
        addfriends(commentId, createById, value).then((res) => {
            if (res.code == 200) {
                layer.alert(res.msg, {icon: 6});
                layer.close(index); // 关闭层
            } else {
                layer.alert(res.msg, {icon: 6});
                layer.close(index); // 关闭层
            }
        })
    });   
}

/**
 * 发送好友消息
 * @param commentId
 * @param createById
 */
function messagefriends(commentId, createById, createBy, createUserAvatar) {
    //layer.msg('给用户:'+"测试"+'好友发消息');
    //miu
    //聊天接口
    layim.chat({
        name: createBy,
        avatar: createUserAvatar,
        id: createById
    });
    $.ajax({
        url: "/mymessage/gethistorymessage",
        type: "post",
        data: {
            senduserid: show_loginuserId,
            touserid: createById,
            meid: show_loginuserId
        },
        async: true,
        cache: false,
        dataType: 'json',
        success: function (res) {
            if (res.code == 200) {
                if (res != null) {
                    var data = res.data;
                    for (var i = 0; i < data.length; i++) {
                        /*   layimGb.getMessage({
                               username: myrealName
                               , avatar: myavatar
                               , id: myuserId
                               , content: "v.content1113333"
                           });*/
                        if (data[i].targetUserid == 'all') {//群发消息
                            layimGb.getMessage({
                                username: '管理员' //秦南厄
                                , avatar: 'https://webdata.qidao123.com/profile/upload/2021/04/28/e2314c28-afff-4801-bb71-f20f9be52282.jpg' //
                                , id: data[i].targetUserid//秦南思,接收
                                , content: data[i].content //
                                //, cid: 0 //
                                , mine: true //是否我发送的消息，如果为true，则会显示在右方
                                , fromid: data[i].userid //消息的发送者id（比如群组中的某个消息发送者），可用于自动解决浏览器多窗口时的一些问题
                                , timestamp: data[i].createTime//服务端时间戳毫秒数。注意：如果你返回的是标准的 unix 时间戳，记得要 *1000
                            });
                        } else {
                            if (data[i].targetUserid != show_loginuserId) {//2->4
                                layimGb.getMessage({
                                    username: data[i].realname //秦南厄
                                    , avatar: data[i].avatar //
                                    , id: data[i].targetUserid//秦南思,接收
                                    , content: data[i].content //
                                    //, cid: 0 //
                                    , mine: true //是否我发送的消息，如果为true，则会显示在右方
                                    , fromid: data[i].userid //消息的发送者id（比如群组中的某个消息发送者），可用于自动解决浏览器多窗口时的一些问题
                                    , timestamp: data[i].createTime//服务端时间戳毫秒数。注意：如果你返回的是标准的 unix 时间戳，记得要 *1000
                                });
                            } else {
                                layimGb.getMessage({
                                    username: data[i].realname //秦南思
                                    , avatar: data[i].avatar
                                    , id: data[i].userid//秦南厄,接收
                                    , content: data[i].content //消息内容
                                    //, cid: 0 //消息id，可不传。除非你要对消息进行一些操作（如撤回）
                                    , mine: false //是否我发送的消息，如果为true，则会显示在右方
                                    , fromid: data[i].userid //发送者
                                    , timestamp: data[i].createTime
                                });
                            }
                        }
                    }
                }
            }
            else {
                console.log("读取消息失败！")
            }
        }
    });

}
/**
 * 发送好友申请
 * @param commentId
 * @param createById
 */
function addfriends(commentId, createById) {
    return $.ajax({
        url: "/message/applyfirends",
        type: "post",
        data: {
            applyTargetUserid: createById
        },
        cache: false,
        dataType: 'json',
        success: function (data) {
            if (data.code == 200) {
                //$('#friend'+commentId).unbind("click");
                $('#friend' + commentId).show();
            } else if (data.code == 601) {
                //layer.msg("加好友失败");
                layer.msg(data.msg);
                layer.confirm(data.msg + '超过一个岗位需要消耗2个金币（对方未通过好友申请不消耗），成为付费会员' +
                    '每天可以加10个好友申请，每个月最多80个。', function (index) {
                        //消耗2金币，如果不足
                        //todo 金币不够则出现金币规则（同个人中心弹窗部分的规则），让用户去赚金牌 同时出现金币支付购买窗口
                        applyfriendbycoin(createById)
                    })
            } else if (data.code == 602) {
                layer.msg(data.msg);
                layer.confirm(data.msg + '超过一个岗位需要消耗2个金币（对方未通过好友申请不消耗），付费会员' +
                    '每天可以加10个好友申请，每个月最多80个。', function (index) {
                        applyfriendbycoin(createById)
                    })
            } else if (data.code == 603) {
                layer.msg(data.msg);
                layer.confirm(data.msg + '超过一个岗位需要消耗2个金币（对方未通过好友申请不消耗），付费会员' +
                    '每天可以加10个好友申请，每个月最多80个。', function (index) {
                        applyfriendbycoin(createById)
                    })
            }

        }
    });
}

function applyfriendbycoin(createById) {
    $.ajax({
        url: "/message/applyfirendsbycoin",
        type: "post",
        async: true,
        data: {
            applyTargetUserid: createById
        },
        cache: false,
        dataType: 'json',
        success: function (data) {
            if (data.code == 200) {
                layer.msg("加好友成功，消耗2金币！")//需先消耗，如果金币不够，后面将消耗不了;如果拒绝就返回2金币
            } else if (data.code == 201) {
                layer.msg(data.msg)
                // 出现金币规则
                aa();
                //todo 出现金币支付购买窗口
            }
            else {
                layer.msg("加好友失败！")
            }
        }

    });
}
function bb(val) {
    $.ajax({
        url: "/job-certification/tovip",
        type: "POST",
        async: true,
        data: {
            isvip: val
        },
        dataType: 'json',
        success: function (data) {
            if (data.code == 200) {//todo 金币不够，不能成功
                layer.msg('恭喜你，金币充值成功!', {
                    time: 2000, //20s后自动关闭
                    icon: 1,
                });
            } else if (data.code == 302) {
                layer.confirm('账户金币不足，对接支付宝充值 ' + val + ' 元吗？', function (index) {
                    var taskName = "购买金币";
                    var bonusMoney = val;
                    $.ajax({
                        url: "/job-certification/tovipzhifu",//需求->购买金币
                        type: "post",
                        async: true,
                        data: {
                            taskName: taskName,
                            bonusMoney: val,//val 0.01 需求->成为vip会员 taskName bonusMoney
                            //taskCategoryId:'eec18c8596b240aeac3de6094dc0c5ec20210110202208840',
                            // distributionMode:10,
                            // onePiecePrice:1,
                            taskTotalMoney: val,// 需求->成为vip会员 taskName bonusMoney
                            // closingDate:'2021-07-05 00:00:00',
                            //taskContent:'123123'
                        },
                        cache: false,
                        dataType: 'json',
                        success: function (data) {
                            if (data.code == 200) {
                                //window.location.replace("/demand");
                                layer.msg("购买金币订单生成", { time: 2000 }, function () {
                                    window.location.replace("/job-certification/page_zhifubao"); //成为vip会员
                                });
                                //ocation.reload();
                            }
                            else {
                                layer.alert(data.msg, { icon: 6 });
                            }
                        }
                    });

                });
            } else {
                layer.msg("接口异常" + '，请联系管理员。', {
                    time: 2000, //20s后自动关闭
                    icon: 1,
                });
            }
            layer.msg(data.msg);
        }

    });
    layer.close(index);
}
function aa() {
    $.ajax({
        url: "/message/getsyscoinconfig",
        type: "post",
        async: true,
        data: {
            aa: 11
        },
        cache: false,
        dataType: 'json',
        success: function (data) {
            if (data.code == 200) {
                var certificationtext = "";
                var jobcerticationltext = "";
                if (data.data.isCertified == '') {
                    certificationtext = '去认证'
                } else {
                    certificationtext = '已认证'
                }
                if (data.data.certication_url == '') {
                    jobcerticationltext = '去认证';
                } else {
                    jobcerticationltext = '已认证';
                }

                //触发事件
                var active = {
                    notice: function () {
                        //示范一个公告层
                        layer.open({
                            type: 1
                            , title: false //不显示标题栏
                            , closeBtn: false
                            , area: '410px;'
                            , shade: 0.8
                            , id: 'LAY_layuipro' //设定一个id，防止重复弹出
                            , btn: ['确定']
                            //,skin:'layer-ext-myskin'
                            , btnAlign: 'c'
                            , moveType: 1 //拖拽模式，0或者1
                            , content: '<div class="text-center mymousenone" style="width:410px;padding: 14px; line-height: 20px; background-color: #393D49; color: #fff; font-weight: 300;" xmlns="http://www.w3.org/1999/html">' +
                                '金币不够，申请好友失败<br>' +
                                '用户可以去赚金币，也可以去<a id="bycoin" class="mygold">购买金币</a><br>' +
                                '选择IT企导网 成就职业人生<br>' +
                                '<div id="picture" class="mt10 mb10" style="height: 40px;"><img src="http://images.qidao123.com/static/1.png" id="myimg"></div>' +
                                '<div>去赚金币</div>' +
                                '<div class="text-left ml10p">' +
                                '<div class="layui-row">\n' +
                                '    <div class="layui-col-xs5 ">\n' +
                                '      <div class="grid-demo grid-demo-bg1">成为实名认证用户：</div>\n' +
                                '    </div>\n' +
                                '    <div class="layui-col-xs3">\n' +
                                '      <div class="grid-demo">+' + data.data.name_certification_gold_coin + '金币</div>\n' +
                                '    </div>\n' +
                                '    <div class="layui-col-xs2">\n' +
                                '      <div class="grid-demo"><button  id="certification"  type="button" class="layui-btn layui-btn-danger layui-btn-radius layui-btn-xs">' +
                                certificationtext +
                                '</button></div>\n' +
                                '    </div>\n' +
                                '  </div>' +
                                '<div class="layui-row">\n' +
                                '    <div class="layui-col-xs5 ">\n' +
                                '      <div class="grid-demo grid-demo-bg1">完善个人简历：</div>\n' +
                                '    </div>\n' +
                                '    <div class="layui-col-xs3">\n' +
                                '      <div class="grid-demo">+' + data.data.fill_myresume_gold_coin + '金币</div>\n' +
                                '    </div>\n' +
                                '    <div class="layui-col-xs2">\n' +
                                '      <div class="grid-demo"><button id="resume" type="button" class="layui-btn layui-btn-danger layui-btn-radius layui-btn-xs">去完善</button></div>\n' +
                                '    </div>\n' +
                                '  </div>' +
                                '<div class="layui-row">\n' +
                                '    <div class="layui-col-xs5 ">\n' +
                                '      <div class="grid-demo grid-demo-bg1">职业认证：</div>\n' +
                                '    </div>\n' +
                                '    <div class="layui-col-xs3">\n' +
                                '      <div class="grid-demo">+' + data.data.job_certification_gold_coin + '金币</div>\n' +
                                '    </div>\n' +
                                '    <div class="layui-col-xs2">\n' +
                                '      <div class="grid-demo"><button id="job2" type="button" class="layui-btn layui-btn-danger layui-btn-radius layui-btn-xs">' +
                                jobcerticationltext +
                                '</button></div>\n' +
                                '    </div>\n' +
                                '  </div>' +
                                '<div class="layui-row">\n' +
                                '    <div class="layui-col-xs5 ">\n' +
                                '      <div class="grid-demo grid-demo-bg1">完成一个真实评价：</div>\n' +
                                '    </div>\n' +
                                '    <div class="layui-col-xs3">\n' +
                                '      <div class="grid-demo">+' + data.data.comment_gold_coin + '金币</div>\n' +
                                '    </div>\n' +
                                '    <div class="layui-col-xs4">\n' +
                                '      <div class="grid-demo"><button id="product2" type="button" class="layui-btn layui-btn-danger layui-btn-radius layui-btn-xs">找产品</button>' +
                                '<button id="solution2" type="button" class="layui-btn layui-btn-danger layui-btn-radius layui-btn-xs">找方案</button></div>\n' +
                                '    </div>\n' +
                                '  </div>' +
                                '<div class="layui-row">\n' +
                                '    <div class="layui-col-xs5 ">\n' +
                                '      <div class="grid-demo grid-demo-bg1">发一个新帖：</div>\n' +
                                '    </div>\n' +
                                '    <div class="layui-col-xs3">\n' +
                                '      <div class="grid-demo">+' + data.data.forum_posting_gold_coin + '金币</div>\n' +
                                '    </div>\n' +
                                '  </div>' +
                                '</div>'
                        });

                        $('#product2').bind("click", function () {
                            window.location.href = "/product2";
                        });
                        $('#solution2').bind("click", function () {
                            window.location.href = "/solution2";
                        });
                        $('#certification').bind("click", function () {
                            window.location.href = "/pinfo-certification";
                        });
                        $('#resume').bind("click", function () {
                            window.location.href = "/resume";
                        });
                        $('#bycoin').bind("click", function () {
                            var val = 2 * 3;//1个金币3元
                            bb(val);
                        });
                        $('#job2').bind("click", function () {
                            layer.open({
                                type: 1 //此处以iframe举例
                                , title: '职业认证'
                                , area: ['460px', '340px']
                                , shade: 0
                                , maxmin: true
                                //,content:'/product2.html'
                                , content: '<div class="text-center ">\n' +
                                    '    <div class="mt10 mb10" >名片、劳动合同、在职证明，多选一上传，后台审核。</div>\n' +
                                    '    <div class="col-lg-12 height190">\n' +
                                    '        <div class="form-group">\n' +
                                    '            <input type="hidden" id="a_yingyezhizhao_address"/>\n' +
                                    '            <div class="layui-upload-drag upload bigload" id="test11">\n' +
                                    '                <i class="layui-icon" style="color: #C0C4CC;"></i>\n' +
                                    '                <p><span class="mydarkred">* </span>点击或者拖拽到此处上传</p>\n' +
                                    '                <div class="layui-hide" id="uploadDemoView_yingyezhizhao">\n' +
                                    '                    <hr>\n' +
                                    '                    <img src="" alt="上传成功后渲染" style="width: 98px">\n' +
                                    '                </div>\n' +
                                    '            </div>\n' +
                                    '        </div>\n' +
                                    '    </div>\n' +
                                    '</div>'
                                , btn: ['上传', '关闭'] //只是为了演示
                                , yes: function () {
                                    var yingyezhizhao_address = $('#a_yingyezhizhao_address').val();//名片地址
                                    if (yingyezhizhao_address == null || yingyezhizhao_address.length <= 0) {
                                        layer.msg("上传职业认证证明！");
                                        return;
                                    } else {
                                        //yingyezhizhao_address="https://webdata.qidao123.com/profile/upload/2021/04/06/e789098d-9c4f-42c2-ac74-7799d388bbfc.png";
                                        certification(yingyezhizhao_address);
                                    }
                                }
                                , btn2: function () {
                                    layer.close();
                                }
                                , zIndex: layer.zIndex //重点1
                            });

                            layui.use('upload', function () {
                                upload = layui.upload;
                                //拖拽上传
                                upload.render({
                                    elem: '#test11'
                                    , url: serverUrl + '/common/upload' //改成您自己的上传接口
                                    , done: function (res) {
                                        if (res.code == 200) {
                                            $('#a_yingyezhizhao_address').val(res.url);
                                            layui.$('#uploadDemoView_yingyezhizhao').removeClass('layui-hide').find('img').attr('src', res.url);
                                            layer.msg('上传成功');
                                        } else {
                                            layer.msg('上传失败');
                                        }
                                    }
                                });
                            });
                        });
                    }
                }
                //0501,暂时关闭，注释打开
                active['notice'].call();
            } else {
                layer.msg("内部接口错误，请联系管理员！")
            }
        }

    });

}
/**
 * 加入黑名单
 * @param commentId
 * @param createById
 */
function addblack(userid) {
    //todo 防重复提交 查询
    $.ajax({
        url: "/mymessage/addblack",
        type: "post",
        data: {
            blackid: userid
        },
        cache: false,
        dataType: 'json',
        async: true,
        success: function (data) {
            if (data.code == 200) {
                layer.msg("加入黑名单成功");
            }
            else {
                layer.msg("加入黑名单失败");
            }

        }
    });
}
/**
 * 关注状态
 * @param commentId
 * @param createById
 */
let fillfollow = function fillfollow(commentId, createById) {
    $.ajax({
        url: "/message/followstatus",
        type: "post",
        data: {
            followUserid: createById
        },
        cache: false,
        dataType: 'json',
        success: function (data) {
            if (data.code == 200) {
                if (data.data == 0) {
                    $('#spguanzhu' + commentId).show();
                    $('#spguanzhu' + commentId).html("关注");
                    $('#spguanzhu' + commentId).bind("click", function () {
                        addfollow(commentId, createById);
                    });
                }
                else if (data.data == 1) {
                    $('#spguanzhu' + commentId).show();
                    $('#spguanzhu' + commentId).html("取消关注");
                    $('#spguanzhu' + commentId).bind("click", function () {
                        cancelfollow(commentId, createById);
                    });
                }
                else {
                    $('#spguanzhu' + commentId).hide();
                }
            }

        }
    });
}
/**
 * 关注状态 所有人
 * @param commentId
 * @param createById
 */
let fillfollow2 = function fillfollow2(commentId, createById) {
    $('#spguanzhu' + commentId).show();
    $('#spguanzhu' + commentId).html("关注");
    $('#spguanzhu' + commentId).bind("click", function () {
        //提示注册并登录
        layer.alert("用户未登录,请<a class='mydarkred' href='/register'>注册</a>并<a class='mydarkred' href='javascript:void(0);'  onclick='openmodal()'>登录</a>!", { icon: 6 });

    });
}
/**
 * 获取评论朋友状态 所有人
 * @param commentId
 * @param createById
 */
let fillfriend2 = function fillfriend2(commentId, createById) {
    $('#friend' + commentId).show();
    $('#friend' + commentId).html("加好友");
    $('#friend' + commentId).bind("click", function () {
        //提示注册并登录
        layer.alert("用户未登录,请<a class='mydarkred' href='/register'>注册</a>并<a class='mydarkred' href='javascript:void(0);'  onclick='openmodal()'>登录</a>!", { icon: 6 });
    });
}
/**
 * 添加关注
 * @param commentId
 * @param createById
 */
let addfollow = function addfollow1(commentId, createById) {
    $.ajax({
        url: "/message/applyfollow",
        type: "post",
        data: {
            followUserid: createById
        },
        cache: false,
        dataType: 'json',
        success: function (data) {
            if (data.code == 200) {
                $('#spguanzhu' + commentId).unbind("click");
                $('#spguanzhu' + commentId).html("取消关注");
                $('#spguanzhu' + commentId).bind("click", function () {
                    cancelfollow(commentId, createById);
                });
                layer.msg("关注成功");
            }

            else {
                layer.msg("关注失败");
            }

        }
    });
}
/**
 * 取消关注
 * @param commentId
 * @param createById
 */
let cancelfollow = function cancelfollow1(commentId, createById) {
    $.ajax({
        url: "/message/cancelfollow",
        type: "post",
        data: {
            followUserid: createById
        },
        cache: false,
        dataType: 'json',
        success: function (data) {
            if (data.code == 200) {
                $('#spguanzhu' + commentId).unbind("click");
                $('#spguanzhu' + commentId).html("关注");
                $('#spguanzhu' + commentId).bind("click", function () {
                    addfollow(commentId, createById);
                });
                layer.msg("取消关注成功");
            }

            else {
                layer.msg("关注失败");
            }

        }
    });
}

let wxlogin = function wxlogin() {
    $.ajax({
        url: "/users/wxlogin",
        type: "get",
        async: true,
        success: function (data) {
            if (data.code == 200) {
                if (data.data != null) {
                    window.location.href = data.data.url;
                }
            } else {
                layer.alert('登录失败!', { icon: 6 });
            }
        }
    });
}

let coinhover = function () {
    /*layer.msg('每个虚拟金币价值3元；注册账户即有5个金币；实名认证 4个金币\n' +
        '职业认证4个金币；\n' +
        '论坛发帖每个0.5个金币；\n' +
        '产品和厂家 点评3个金币\n' +
        '个人实名认证：  金币4个\n' +
        '完善个人简历：  金币3个；',{
        //icon: 16,
        time: 100000,
        //shade : [0.5 , '#393D49' , true]
        }
        );*/
    layer.open({
        type: 1
        , title: false //不显示标题栏
        , closeBtn: false
        , area: ['390px']
        , shade: 0
        , offset: 't'
        , content: '<div class="text-left" style="padding: 14px; line-height: 20px; background-color: #eeeeee; color: #333; font-weight: 300;" xmlns="http://www.w3.org/1999/html">' +
            '&nbsp;&nbsp;&nbsp;&nbsp;每个虚拟金币价值3元；注册账户即有5个金币；实名认证4个金币\n' +
            '职业认证3个金币；\n' +
            '论坛发帖每个0.5个金币；\n' +
            '产品和厂家点评3个金币；\n' +
            '完善个人简历币3个；' +
            '</div>'
        /* ,btn: ['继续弹出', '全部关闭'] //只是为了演示
         ,yes: function(){
             $(that).click();
         }
         ,btn2: function(){
             layer.closeAll();
         }*/

        , zIndex: layer.zIndex //重点1
        , success: function (layero) {
            layer.setTop(layero); //重点2
        }
    });
}
let coinout = function () {
    layer.closeAll();
}


/**
 * 查看用户资料
 * @param commentId
 */
let wholookmyinfo = function wholookmyinfo(createrId) {
    $.ajax({
        url: "/users/lookmyinfo",
        type: "post",
        data: {
            createrId: createrId,
        },
        cache: false,
        dataType: 'json',
        success: function (data) {
            if (data.code == 200) {
                window.location.href = "/myinfo?createrId=" + createrId;
            }
            else {
                layer.alert(data.msg, { icon: 6 });
            }
        }

    });
}

/**
 * 查看个人资料
 * @param commentId
 */
export const getpersonalcnt = () => {
    let authdata = localStorage.getItem("authdata")
    if (authdata == null) {
        layer.alert('用户未登陆!', { icon: 6 });
        return;
    }
    authdata = JSON.parse(authdata)
    let userId = authdata.data.userId
    let token = localStorage.getItem("token")
    let data = { "userid": userId };
    $.ajax({
        //url:"/message/getfirendscntandothers",
        url: serverUrl + "/message/getfirendsectcnt",
        type: "post",
        async: true,
        data: JSON.stringify(data),
        dataType: "json",
        contentType: "application/json",
        headers: {
            "Authorization": "Api_Bearer " + token,
            'Content-Type': 'application/json'
        },
        success: function (data) {
            if (data.code == 200) {
                // 好友数量
                let myfriendcnt = data.data.myfriendcnt;
                let todayFiriendTotal = data.data.todayFiriendTotal;
                if (todayFiriendTotal > 0) {
                    todayFiriendTotal = "+"+todayFiriendTotal;
                }
                let myfriendcnthtml = myfriendcnt;
                if (todayFiriendTotal != 0) {
                    myfriendcnthtml += '<span class="layui-badge-dot layui-bg-red" style="width:18px;height:18px;padding-top:2px;margin-top:-5px;position:absolute">'+todayFiriendTotal+'</span>';
                }
                $('#myfriendcnt').html(myfriendcnthtml);

                // 被关注总数
                let myattentioncnt = data.data.myattentioncnt;
                // 今日被关注
                let todaymyattentioncnt = data.data.todaymyattentioncnt;
                if (todaymyattentioncnt > 0) {
                    todaymyattentioncnt = "+"+todaymyattentioncnt;
                }
                let myattentionhtml = '<a class="myyellow" href="/message-follow?code=1" style="color: #e2cead !important;">'+myattentioncnt+'</a>';
                if (todaymyattentioncnt != 0) {
                    myattentionhtml += '<span class="layui-badge-dot layui-bg-red" style="width:18px;height:18px;padding-top:2px;margin-top:-5px;position:absolute">'+todaymyattentioncnt+'</span>';
                }
                $('#myattentioncnt').html(myattentionhtml);

                // 他关注的人
                let myattentioncnted = data.data.myattentioncnted;
                // 今日他关注的人
                let todaymyattentioncnted = data.data.todaymyattentioncnted;
                if (todaymyattentioncnted > 0) {
                    todaymyattentioncnted = "+"+todaymyattentioncnted;
                }
                let myattentionedhtml = '<a class="myyellow" href="/message-follow" style="color: #e2cead !important;">'+myattentioncnted+'</a>';
                if (todaymyattentioncnted != 0) {
                    myattentionedhtml += '<span class="layui-badge-dot layui-bg-red" style="width:18px;height:18px;padding-top:2px;margin-top:-5px;position:absolute">' +todaymyattentioncnted+"</span>";
                }
                $('#myattentioncnted').html(myattentionedhtml);

                // 访客
                let myvisitcnt = '<a class="myyellow" href="/message-visit" style="color: #e2cead !important;">'+data.data.myvisitcnt+'</a>';
                let todayvisitTotal = "+"+data.data.todayvisitTotal;
                if (todayvisitTotal != 0) {
                    myvisitcnt += '<span class="layui-badge-dot layui-bg-red" style="width:18px;height:18px;padding-top:2px;margin-top:-5px;position:absolute";left:40px>' +todayvisitTotal+"</span>";
                }
                $('#myvisitcnt').html(myvisitcnt);
            }
            else {
                layer.alert("个人资料查询失败！", { icon: 6 });
            }
        }

    });
}

function gotomyfriends() {
    window.location.href = "/message-friends";
}

function mouseover(aa) {
    aa.style.cssText = "cursor:pointer";
}

//发送站内消息
function sendMsg(from, content, to) {
    $.ajax({
        url: "/personal/addmessage",
        type: "post",
        async: true,
        data: {
            myuserid: from,
            touserid: to,
            message: content
        },
        cache: false,
        dataType: 'json',
        success: function (data) {
            if (data.code == 200) {
                //layer.msg("消息发送成功！")
                //gatmm(curpagenum);
            }
            else {
                layer.msg("消息发送失败！")
            }
        }
    });
}

function isEmpty(property) {
    return (property === null || property === "" || typeof property === "undefined");
}

function layerclose(index) {
    layer.close(index);
}

/**
 * 保存咨询数据
 */
export const addcontact = (askType,_this) => {
    let that = _this
    var consultationContent = $('#txtconsultationContent').val();
    var contacts = $('#txtcontacts').val();
    var companyName = $('#txtcompanyName').val();
    var email = $('#txtemail').val();
    var phone = $('#txtphone').val();
    var verCode = $('#txtverCode').val();
    var productid = $('#inputproductid').val();
    var inputcontactmenu = $("#inputcontactmenu").val();
    var inputcontacturl = $("#inputcontacturl").val();
    if (askType == null || askType.length <= 0) {
        layer.alert('请输入咨询类别!', { icon: 6 });
        return;
    }
    if (consultationContent == null || consultationContent.length <= 0) {
        layer.alert('请输入咨询的问题!', { icon: 6 });
        return;
    }
    if(askType == 2 && consultationContent.length < 30){
        layer.alert('您的描述不够清楚，我们无法帮助您信息保密：请返回补充完善！(询价至少30字)', { icon: 6 });
        return;
    }
    if(consultationContent.length < 20){
        layer.alert('您的描述不够清楚，我们无法帮助您信息保密：请返回补充完善！(至少20字)', { icon: 6 });
        return;
    }
    if (contacts == null || contacts.length <= 0) {
        layer.alert('请输入联系人!', { icon: 6 });
        return;
    }
    if (companyName == null || companyName.length <= 0) {
        layer.alert('请输入公司!', { icon: 6 });
        return;
    }
    if (contacts.length < 2) {
        layer.alert('姓名不少于两个字,请输入真实信息,方便对接', { icon: 6 });
        return;
    }
    if (companyName.length < 2) {
        layer.alert('公司名不少于两个字,请输入真实信息,方便对接', { icon: 6 });
        return;
    }
    if (email == null || email.length <= 0) {
        layer.alert('请输入邮箱!', { icon: 6 });
        return;
    }
    if (phone == null || phone.length <= 0) {
        layer.alert('请输入手机号!', { icon: 6 });
        return;
    }
    if (localStorage.getItem('showLogin') == 0 && (verCode == null || verCode.length <= 0)) {
        layer.alert('请输入验证码!', { icon: 6 });
        return;
    }

    let operationType = 2;
    let operationId = '首页';

    let data = {
        'code': verCode,
        'phone': phone,
        'operationId': operationId,
        'email': email,
        'contacts': contacts,
        'companyName': companyName,
        'consultationContent': consultationContent,
        'operationType': operationType,
        'title': inputcontactmenu,
        'url': inputcontacturl,
        'askType':askType,
    };
    updatevisitdetaildata('basics.py', 'addconsultingdata')
    let headers = localStorage.getItem("token") ? {
        "username": localStorage.getItem("username"),
        "Authorization": "Api_Bearer " + localStorage.getItem("token"),
        'Content-Type': 'application/json'
    } : {
        'Content-Type': 'application/json'
    };
    $.ajax({
        url: serverUrl + "/basics/addconsultingdata",
        type: "post",
        async: true,
        data: JSON.stringify(data),
        dataType: "json",
        contentType: "application/json",
        headers: headers,
        success: function (data) {
            if (data.code == 200) {
                // layer.msg('提交成功!', { icon: 6 });
                let css = document.getElementsByClassName('layui-layer-dialog');
                for (let i = 0; i < css.length; i++) {
                    if(css[i].className.indexOf('layer-anim') == -1){
                        css[i].style.display = 'none'
                    }
                }
                $('#contactModal').modal("hide");
                that.dialogVisible = true
            }
            else {
                layer.alert(data.msg, { icon: 6 });
                let css = document.getElementsByClassName('layui-layer-dialog');
                for (let i = 0; i < css.length; i++) {
                    if(css[i].className.indexOf('layer-anim') == -1){
                        css[i].style.display = 'none'
                    }
                }
            }
        }

    });

}
